import Avatar, { type AvatarProps } from "@mui/material/Avatar";
import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";

interface StyledAvatarProps extends AvatarProps {
  isDisabled?: boolean;
}

export const StyledAvatar = styled(Avatar, {
  shouldForwardProp: (prop) => prop !== "isDisabled",
})<StyledAvatarProps>(({ theme, isDisabled }) => ({
  backgroundColor: isDisabled ? theme.palette.grey[400] : theme.palette.primary.main,
  width: 42,
  height: 42,
}));

export const UserInfoContainer = styled(Box)(({ theme }) => ({
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),
  paddingTop: theme.spacing(1.5),
  paddingBottom: theme.spacing(1.5),
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(2),
}));

export const MenuItemsContainer = styled(Box)(({ theme }) => ({
  paddingTop: theme.spacing(1),
}));
